import classNames from "classnames";
import { FC, ReactNode } from "react";

interface FlightProgressBarProps {
  progress: number;
  className?: string;
  head:ReactNode;
}

const ProgressLoader: FC<FlightProgressBarProps> = ({ progress, className, head }) => {
  const clamped = Math.min(100, Math.max(0, progress));

  return (
    <div className={classNames("relative w-full h-1 bg-background-subtle rounded-full", className)}>
      <div
        className="absolute start-0 top-0 h-full bg-background-primary rounded-full duration-200"
        style={{ width: `${clamped}%` }}
      />
      <div
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 rtl:translate-x-1/2 text-icon-active transition-all duration-200"
        style={{ insetInlineStart: `${clamped}%` }}
      >
        {head}
      </div>
    </div>
  );
};

export default ProgressLoader;